<template lang="pug">
  .component-create-plan(v-if="toc !== null")
    .row
      .columns
        label Name
          input(type="text", v-model="toc.name")
      .columns
        label Toc Type
          selectize-toc-type(@optionSelected="setTocType", :selectedValue="toc.toc_type.id")
      .columns
        label Version
          input(type="text", v-model="toc.version")

    .row
      .columns
        label Required from
          DatePicker(v-model="toc.required_from", :initialDate="toc.required_from")
      .columns
        label Optional
        input(type="checkbox", v-model="toc.optional")

      .columns
        label Disabled
        input(type="checkbox", v-model="toc.disabled")
    .row
      .columns
        label Acceptance statement
          input(type="text", v-model="toc.acceptance_statement")
        label External url
          input(type="text", v-model="toc.link")


      .columns
        label Priority
          input(type="text", v-model="toc.priority")
        KeplerFileUpload(selected-prefix="tocs", selected-visibility="public",  @sel="handleFileSelector", :preview-url="toc.attachment")
    .row.columns
      label Content
      Editor(v-model="toc.content")
      button.button(@click="createToc") Save

</template>
<script type="text/babel">

  import DatePicker from '../../components/structure/DatePicker'
  import SelectizeTocType from '../../components/structure/ui/lists/selectize/SelectizeTocType'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import KeplerFileUpload from '../../components/structure/KeplerFileUpload'
  import MaggieHelper from '../../maggieHelper'
  import Editor from '../../components/structure/ui/Editor'

  export default {
    name: 'CreateToc',
    components: {Editor, KeplerFileUpload, SelectizeTocType, DatePicker},
    data() {
      return {
        toc: {
          id: null,
          content: '',
          required_from: null,
          link: null,
          attachment: null,
          name: null,
          acceptance_statement: null,
          version: null,
          optional: 0,
          priority: 0,
          toc_type: {
            id: 1,
            name: null,
            group: null,
            priority: 0,
            uid: null
          },
          disabled: false,
        }
      }
    },
    computed: {},
    mounted() {
    },
    created() {
      if (this.$route.params.id) {
        this.toc = null
        KeplerBackofficeSdk.tocs.select(this.$route.params.id).get((data) => {
          this.toc = Object.assign({}, data)
          this.toc.toc_type_id = data.toc_type_id
        })
      }
    },
    methods: {
      setTocType(obj) {
        this.toc.toc_type_id = obj.id
      },
      createToc() {
        if (this.$route.params.id) {
          KeplerBackofficeSdk.tocs.select(this.toc.id).edit(this.toc, (data) => {
            MaggieHelper.notification('edited', 'Toc edited successfully')
            this.$router.push({name: 'tocs'})
          })
        } else {
          KeplerBackofficeSdk.tocs.make(this.toc, (data) => {
            MaggieHelper.notification('created', 'Toc created successfully')
            this.$router.push({name: 'tocs'})
          })
        }

      },
      handleFileSelector(path) {
        this.toc.attachment = path
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-create-plan
    background: white
    padding: 1em 2em

</style>



// WEBPACK FOOTER //
// CreateToc.vue?1cf2b362